import React from 'react';
import { FaEnvelope, FaMapMarkedAlt, FaClock, FaPhoneAlt, FaCheckSquare } from 'react-icons/fa';

const contacts = [  
    { 
        id: 1, 
        icon: <FaCheckSquare />,
        title: '統一編號',
        content: [ '統編：27719080'],
    },
    { 
        id: 2, 
        icon: <FaPhoneAlt />,
        title: '聯絡我們',
        content: [ '(02)8913-6689'],
    },
    {
        id: 3,
        icon: <FaEnvelope />,
        title: '電子信箱',
        content: [ 'parkingservice@10parking.com'],
    },
    {
        id: 4,
        icon: <FaMapMarkedAlt />,
        title: '公司地址',
        content: ['23150新北市新店區中央路159號4樓'],
    },
    {
        id: 5,
        icon: <FaClock />,
        title: '營業時間',
        content: ['Working day(9AM - 6PM)'],
    },
 
];

export default contacts;